var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import classNames from "classnames";
import * as userSettingsActions from "../../../users/actions/userSettings";
import * as authDrawerActions from "../../../actions/authDrawer";
import * as authDrawerConstants from "../../../constants/authDrawer";
import analytics from "../../../utils/analytics";

import styles from "./SaveTag.css";

import Icon from "../Icon";

var SaveTag = function (_Component) {
  _inherits(SaveTag, _Component);

  function SaveTag() {
    _classCallCheck(this, SaveTag);

    var _this = _possibleConstructorReturn(this, (SaveTag.__proto__ || Object.getPrototypeOf(SaveTag)).call(this));

    _this.saveStory = _this.saveStory.bind(_this);
    return _this;
  }

  _createClass(SaveTag, [{
    key: "saveStory",
    value: function saveStory() {
      var _this2 = this;

      // If we are not logged in, open the auth drawer
      if (!this.props.authDrawer.loggedIn) {
        this.props.authDrawerActions.changeStep(authDrawerConstants.SIGNIN);
        return this.props.authDrawerActions.toggleAuthDrawer(true);
      }

      var savedStories = this.props.userSettings.data.profileInfo.savedStoryIds;

      // Save a story if not already saved
      if (savedStories && savedStories.indexOf(this.props.storyId) < 0) {
        analytics.userClicksSaveTag(this.props.stream);
        var newSavedStories = savedStories.concat(this.props.storyId);

        this.props.userSettingsActions.submitSavedStories(newSavedStories);
      }

      // Remove a saved story if previously saved
      if (savedStories && savedStories.indexOf(this.props.storyId) >= 0) {
        var _newSavedStories = savedStories.filter(function (savedStory) {
          return savedStory !== _this2.props.storyId;
        });

        this.props.userSettingsActions.submitSavedStories(_newSavedStories);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var saved = this.props.userSettings.data.profileInfo.savedStoryIds.indexOf(this.props.storyId) >= 0;

      return React.createElement(
        "div",
        { onClick: this.saveStory, className: classNames(styles.root, this.props.absolute ? styles.absolute : {}) },
        React.createElement(
          "span",
          { className: classNames(styles.save, _defineProperty({}, styles.saved, saved)) },
          "Save",
          saved && "d"
        ),
        React.createElement(Icon, { name: "save", description: "Save story", className: classNames(styles.icon, saved ? styles.saved : {}) })
      );
    }
  }]);

  return SaveTag;
}(Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    userSettings: state.userSettings,
    authDrawer: state.authDrawer
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    userSettingsActions: bindActionCreators(userSettingsActions, dispatch),
    authDrawerActions: bindActionCreators(authDrawerActions, dispatch)
  };
};

SaveTag.propTypes = {
  absolute: PropTypes.bool,
  storyId: PropTypes.string.isRequired,
  stream: PropTypes.string,
  userSettings: PropTypes.shape({
    data: PropTypes.shape({
      profileInfo: PropTypes.shape({
        savedStoryIds: PropTypes.array.isRequired
      }).isRequired
    }).isRequired
  }).isRequired,
  authDrawer: PropTypes.shape({
    loggedIn: PropTypes.bool
  }).isRequired,
  userSettingsActions: PropTypes.shape({
    submitSavedStories: PropTypes.func.isRequired
  }).isRequired,
  authDrawerActions: PropTypes.shape({
    changeStep: PropTypes.func.isRequired,
    toggleAuthDrawer: PropTypes.func.isRequired
  }).isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(SaveTag);


// WEBPACK FOOTER //
// ./src/components/Library/SaveTag/SaveTag.js